import React from 'react';
import MainWrapper from './components/MainWrapper'

function App() {
  console.error("Are you hiring? 🙃")
  return (
      < MainWrapper />
  );
}

export default App;
